<ng-container *transloco="let t">
  <div class="dialog-overlay" (click)="onOverlayClick($event)">
    <section
      class="dialog-container"
      role="dialog"
      aria-modal="true"
      [attr.aria-labelledby]="titleId"
      [attr.aria-describedby]="descriptionId"
      cdkTrapFocus
      cdkTrapFocusAutoCapture
      (click)="$event.stopPropagation()">
      <header class="dialog-header">
        <h2 class="dialog-title" [id]="titleId">
          {{ t('lang.file_selection_discard_title') }}
        </h2>
        <p class="dialog-subtitle" [id]="descriptionId">
          {{ t('lang.file_selection_discard_description') }}
        </p>
        <button
          type="button"
          class="close-button"
          data-testid="close-dialog"
          [disabled]="busy"
          [attr.aria-label]="t('lang.close')"
          (click)="keepEditing.emit()">
          <mzic-svg src="assets/icons/mzic-close.svg" />
        </button>
      </header>

      @if (fileNames.length > 0) {
        <div class="dialog-content" data-testid="selected-file-names">
          {{ fileNames.join(', ') }}
        </div>
      }

      <footer class="dialog-footer">
        <button
          type="button"
          class="danger-button"
          data-testid="discard-selection"
          [disabled]="busy"
          (click)="onDiscard()">
          {{ t(discardActionKey) | uppercase }}
        </button>
        <button
          #keepEditingButton
          type="button"
          class="secondary-button"
          data-testid="keep-editing"
          cdkFocusInitial
          [disabled]="busy"
          (click)="keepEditing.emit()">
          {{ t('lang.file_selection_keep_editing') | uppercase }}
        </button>
      </footer>
    </section>
  </div>
</ng-container>
